import TableColumn from './TableColumn'
import getDisplayName from '../utils/getDisplayName'
import shallowEqual from 'fbjs/lib/shallowEqual'
import React, { Children, cloneElement } from 'react'

export default function selectableTable(
  dataGetter,
  onSelect,
  { trackBy, initialize }
) {
  let tableInstance

  if (process.env !== 'production') {
    if (initialize && !trackBy) {
      throw new Error(
        'You must provide the trackBy option when using initialize'
      )
    }
  }

  function toggleRow(collection, rowData, index, selected, props) {
    const key = rowData[trackBy] || index

    onSelect(rowData, selected, props, index, tableInstance)

    return Object.assign({}, collection, {
      [key]: selected
    })
  }

  function toggleAll(data, selected, props) {
    return data.reduce((memo, rowData, index) => {
      return toggleRow(memo, rowData, index, selected, props)
    }, {})
  }

  return function decorateComponent(Component) {
    return class SelectableTable extends React.Component {
      static displayName = `SelectableTable(${getDisplayName(Component)})`

      constructor(props) {
        super(props)

        this.handleSelect = this.handleSelect.bind(this)
        this.handleSelectAll = this.handleSelectAll.bind(this)
        this.renderSelect = this.renderSelect.bind(this)
        this.renderSelectHeader = this.renderSelectHeader.bind(this)
        this.renderSelectableTable = this.renderSelectableTable.bind(this)

        let selectedRows = {}
        if (initialize) {
          const selectedIds = initialize(props)
          const items = dataGetter(props)

          selectedIds.forEach(id => {
            selectedRows[id] = items.find(item => item.id === id)
          })
        }

        this.state = {
          allSelected: false,
          selectedRows
        }
      }

      shouldComponentUpdate(nextProps, nextState) {
        return (
          !shallowEqual(this.props, nextProps) ||
          !shallowEqual(this.state, nextState)
        )
      }

      getSelectableColumn() {
        return (
          <TableColumn
            cellRenderer={this.renderSelect}
            key="selectableColumn"
            dataKey="selectableTableExpanded"
            headerRenderer={this.renderSelectHeader}
            label=""
            width={10}
          />
        )
      }

      handleSelect(e, rowData, index) {
        const { selectedRows } = this.state

        this.setState({
          selectedRows: toggleRow(
            selectedRows,
            rowData,
            index,
            e.target.checked,
            this.props
          )
        })
      }

      handleSelectAll(e) {
        this.setState({
          allSelected: e.target.checked,
          selectedRows: toggleAll(
            // TODO: Get rid of dataGetter and read from Table props instead
            dataGetter(this.props),
            e.target.checked,
            this.props
          )
        })
      }

      renderSelect(selected, rowData, dataKey, index) {
        return (
          <input
            type="checkbox"
            checked={this.rowIsSelected(rowData, index)}
            onChange={e => this.handleSelect(e, rowData, index)}
          />
        )
      }

      renderSelectHeader() {
        const { allSelected } = this.state

        return (
          <input
            type="checkbox"
            checked={allSelected}
            onChange={this.handleSelectAll}
          />
        )
      }

      renderSelectableTable(Table) {
        return cloneElement(Table, {}, [
          this.getSelectableColumn(),
          ...Children.toArray(Table.props.children)
        ])
      }

      rowIsSelected(rowData, index) {
        const key = rowData[trackBy] || index
        return this.state.selectedRows[key]
      }

      render() {
        const { selectedRows } = this.state
        return (
          <Component
            ref={table => (tableInstance = table)}
            connectSelectableColumn={this.renderSelectableTable}
            selectedRows={selectedRows}
            {...this.props}
          />
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ../src/components/SelectableTable.js